var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('drawer',{attrs:{"drawer":_vm.drawer},on:{"drawer":_vm.setDrawer}}),_c('v-main',[_c('v-container',{staticClass:"page-content-container"},[_c('router-view')],1)],1),_c('offline-popup')],1)}
var staticRenderFns = []

export { render, staticRenderFns }